export const BRAND = {
  name: "Valientes Cenizas Shop",
  whatsapp: "17209686008", // E.164 without +
  whatsappDisplay: "+1 (720) 968-6008",
  smsNumber: "+17209686008", // number that receives the order SMS
  city: "Glen Saint Mary, Florida",
  country: "Estados Unidos",
  email: "valientescenizas@valientescenizas.com",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
